import LinearProgress from '@mui/material/LinearProgress';
import Typography from '@mui/material/Typography';
import {formatNumber} from 'main/utility/helper/FormatUtil';
import PropTypes from 'prop-types';

const AppProgressText = (props) => {
  const {
    thickness = 3,
    variant = 'determinate',
    value,
    pathColor = '#F5F6FA',
    activeColor = '#00905F',
    textColor = '#000000',
    borderRadius = 10,
    pattern = '99.99',
  } = props;
  return (
    <div style={{height: thickness, textAlign: 'center'}}>
      <LinearProgress
        variant={variant}
        value={value}
        sx={{
          height: thickness,
          border: 0.5,
          borderColor: '#DCDCDC',
          borderRadius: borderRadius,
          backgroundColor: pathColor,
          '& .MuiLinearProgress-bar': {
            backgroundColor: activeColor,
          },
        }}
      />
      <Typography
        style={{height: thickness}}
        variant='body2'
        display='inline-block'
        sx={{
          color: textColor,
          fontWeight: 500,
          position: 'relative',
          transform: 'translateY(-100%)',
          textAlign: 'center',
          p: 1,
        }}
      >
        {props.prefix + formatNumber(value.toString(), pattern) + props.suffix}
      </Typography>
    </div>
  );
};

AppProgressText.propTypes = {
  thickness: PropTypes.number,
  borderRadius: PropTypes.number,
  pathColor: PropTypes.string,
  activeColor: PropTypes.string,
  textColor: PropTypes.string,
  variant: PropTypes.oneOf(['buffer', 'determinate', 'indeterminate', 'query']),
  value: PropTypes.number,
  pattern: PropTypes.string,
  prefix: PropTypes.string,
  suffix: PropTypes.string,
};

export default AppProgressText;
